import axios from 'axios';
import sha256 from 'crypto-js/sha256';
import CryptoJS from 'crypto-js';
import { toast } from 'react-toastify';
import ApiHelper from 'utils/apiHelper';
import { API_URL } from 'utils/constants';
import ACTION_TYPE from 'components/../redux/actions/actionTypes';
import localStorage from 'redux-persist/es/storage';
//import { useAuth0 } from '@auth0/auth0-react';

export const authLogin =
    ({ username, password }, navigate) =>
    async (dispatch) => {
        try {
            // configure header's Content-Type as JSON
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            const headers = {
                'Content-Type': 'application/json'
            };
            const encryptedPwd = sha256(password).toString(CryptoJS.enc.Hex);
            const timezoneOffSet = new Date().getTimezoneOffset();
            const { data } = await ApiHelper.post(
                API_URL.AUTH_URL,
                { username, password: encryptedPwd, tz: -timezoneOffSet },
                headers,
                {},
                false
            );
            if (data.status === 200) {
                if (data.activeTwoFactor) {
                    console.log(username, password);
                    navigate('/two-factor', { state: { username, password } });
                } else {
                    await localStorage.setItem('userToken', data.token);
                    dispatch({
                        type: ACTION_TYPE.AUTH_SUCCESS,
                        data
                    });
                    dispatch({
                        type: ACTION_TYPE.UPDATE_MANAGEMENT_DTL,
                        fieldName: 'organization',
                        data: {
                            selected: null,
                            data: []
                        }
                    });
                }
            } else {
                toast.error('Invalid credentials');
                dispatch({
                    type: ACTION_TYPE.AUTH_FAILED,
                    data: 'Invalid credentials'
                });
            }
        } catch (error) {
            // return custom error message from API if any
            let msg = 'Invalid credentials';
            if (error.response.status === 401) {
                msg = "You haven't validated your account yet";
            } else if (error.response.status === 403) {
                msg = 'Your account has been locked!';
            } else if (error.response.status === 500) {
                msg = 'Server Error!';
            }
            toast.error(msg);
            dispatch({
                type: ACTION_TYPE.AUTH_FAILED,
                data: msg
            });
        }
    };

export const auth0Login =
    ({ token }, navigate) =>
    async (dispatch) => {
        try {
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            };
            const timezoneOffSet = new Date().getTimezoneOffset();
            const { data } = await ApiHelper.post(API_URL.AUTH0_URL, { tz: -timezoneOffSet }, headers, {}, false);
            if (data.status === 200) {
                if (data.activeTwoFactor) {
                    console.log('Auth0 user requires two-factor authentication');
                    // Handle 2FA for Auth0 users if needed
                    navigate('/two-factor', { state: { isAuth0: true, token } });
                } else {
                    await localStorage.setItem('userToken', data.token);
                    dispatch({
                        type: ACTION_TYPE.AUTH_SUCCESS,
                        data
                    });
                    dispatch({
                        type: ACTION_TYPE.UPDATE_MANAGEMENT_DTL,
                        fieldName: 'organization',
                        data: {
                            selected: null,
                            data: []
                        }
                    });
                }
            } else {
                toast.error('Invalid credentials');
                dispatch({
                    type: ACTION_TYPE.AUTH_FAILED,
                    data: 'Invalid credentials'
                });
            }
        } catch (error) {
            // return custom error message from API if any
            let msg = 'Invalid credentials';
            if (error.response && error.response.status === 401) {
                msg = "You haven't validated your account yet";
            } else if (error.response && error.response.status === 403) {
                msg = 'Your account has been locked!';
            } else if (error.response && error.response.status === 500) {
                msg = 'Server Error!';
            }
            toast.error(msg);
            dispatch({
                type: ACTION_TYPE.AUTH_FAILED,
                data: msg
            });
        }
    };

export const ssoLogin =
    ({ token }, navigate, returnTo) =>
    async (dispatch) => {
        try {
            // The ACS callback handed us a Knox token in the URL. Persist it so the
            // authed handshake request (and the rest of the session) can use it.
            await localStorage.setItem('userToken', token);
            const { data } = await ApiHelper.get(API_URL.SSO_HANDSHAKE);
            if (data.status === 200) {
                dispatch({
                    type: ACTION_TYPE.AUTH_SUCCESS,
                    data: { ...data, token }
                });
                dispatch({
                    type: ACTION_TYPE.UPDATE_MANAGEMENT_DTL,
                    fieldName: 'organization',
                    data: {
                        selected: null,
                        data: []
                    }
                });
                navigate(returnTo && returnTo !== '/' ? returnTo : '/home');
            } else {
                await localStorage.removeItem('userToken');
                toast.error('SSO sign-in failed.');
                dispatch({
                    type: ACTION_TYPE.AUTH_FAILED,
                    data: 'SSO sign-in failed.'
                });
            }
        } catch (error) {
            await localStorage.removeItem('userToken');
            toast.error('SSO sign-in failed.');
            dispatch({
                type: ACTION_TYPE.AUTH_FAILED,
                data: 'SSO sign-in failed.'
            });
        }
    };

export const authTwoFactor =
    ({ code, username, password }) =>
    async (dispatch) => {
        try {
            const headers = {
                'Content-Type': 'application/json'
            };
            const encryptedPwd = sha256(password).toString(CryptoJS.enc.Hex);
            const timezoneOffSet = new Date().getTimezoneOffset();
            const { data } = await ApiHelper.post(
                API_URL.AUTH_TWO_FACTOR,
                { username, password: encryptedPwd, tz: -timezoneOffSet, code },
                headers,
                {},
                false
            );
            if (data.status === 200) {
                await localStorage.setItem('userToken', data.token);
                dispatch({
                    type: ACTION_TYPE.AUTH_SUCCESS,
                    data
                });
                dispatch({
                    type: ACTION_TYPE.UPDATE_MANAGEMENT_DTL,
                    fieldName: 'organization',
                    data: {
                        selected: null,
                        data: []
                    }
                });
            } else {
                toast.error(data.message);
                dispatch({
                    type: ACTION_TYPE.AUTH_FAILED,
                    data: 'Invalid credentials'
                });
            }
        } catch (error) {
            let msg = 'Invalid credentials';
            if (error.response.status === 401) {
                msg = "You haven't validated your account yet";
            } else if (error.response.status === 403) {
                msg = 'Your account has been locked!';
            } else if (error.response.status === 500) {
                msg = 'Server Error!';
            }
            toast.error(msg);
            dispatch({
                type: ACTION_TYPE.AUTH_FAILED,
                data: msg
            });
        }
    };

export const getUserDetails = () => async (dispatch) => {
    try {
        // configure authorization header with user's token
        const response = await ApiHelper.get(API_URL.USER_INFO);
        if (response.status === 200) {
            dispatch({
                type: ACTION_TYPE.AUTH_USERINFO,
                data: response.data
            });
        } else {
            toast.error('Invalid credentials');
        }
    } catch (error) {
        // toast.error('Your authentication has expired, please login again.');
        dispatch({
            type: ACTION_TYPE.AUTH_USERINFO_FAILED,
            data: error.response.message
        });
    }
};

export const logout = () => async (dispatch, getState) => {
    // configure header's Content-Type as JSON
    const token = localStorage.getItem('userToken');
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}` // Add this line if token-based authentication is used
    };
    const userInfoState = getState();
    const userInfo = userInfoState.auth.userInfo.user;
    const { id, orgid } = userInfo;
    const { status } = await ApiHelper.post(API_URL.NOTIFY_LOGOUT, { label: 'logout', orgid: orgid.orgid, userid: id }, headers, {}, false);
    //const { isAuthenticated } = useAuth0();

    if (status === 200) {
        await localStorage.removeItem('userToken'); // delete token from storage
        dispatch({
            type: ACTION_TYPE.AUTH_LOGOUT
        });
    } else {
        toast.error('Confirm NetWork!');
    }
};
